import { useState } from 'react';
import apiService from '../../services/api';
import logger from '../../utils/logging/logger';

export default function useForgotUsernameModal({ onClose }) {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [foundEmail, setFoundEmail] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (error) setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess(false);
    setFoundEmail('');

    try {
      const response = await apiService.forgotUsername(formData.firstName, formData.lastName);

      if (response.success) {
        setSuccess(true);
        setFoundEmail(response.email);
      } else {
        setError(response.error || 'Account not found. Please contact admin@faithinsight.org for assistance.');
      }
    } catch (error) {
      logger.error('Forgot username error', { error, firstName: formData.firstName, lastName: formData.lastName });
      setError('Account not found. Please contact admin@faithinsight.org for assistance.');
    }

    setLoading(false);
  };

  const handleClose = () => {
    setFormData({ firstName: '', lastName: '' });
    setError('');
    setSuccess(false);
    setFoundEmail('');
    onClose();
  };

  const handleBackToLogin = () => {
    handleClose();
  };

  return {
    formData,
    loading,
    error,
    success,
    foundEmail,
    handleChange,
    handleSubmit,
    handleClose,
    handleBackToLogin
  };
}
